export const isProd = import.meta.env.VITE_MODE === "prod";

export const APP_URL = `${window.location.protocol}//${
  window.location.hostname
}${window.location.port ? `:${window.location.port}` : ""}`;
